import React from "react";
import AppBreadcrumb from "components/layout-components/AppBreadcrumb";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { media } from "../../styles/breakpoints";

export const PageHeader = ({ title, display }) => {
  const { t } = useTranslation();
  return display ? (
    <Wrapper>
      <h3 className="font-weight-semibold">{title ? t(title) : "Home"}</h3>
      <AppBreadcrumb t={t} />
    </Wrapper>
  ) : null;
};

const Wrapper = styled.div`
  ${media.mobile`
    margin-left: 6px;
    margin-block: 4px;
  `}

  h3 {
    margin-bottom: 0;
  }
`;

export default PageHeader;
